import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';


import { Permissao } from '../../model';

import { API, ITENSPORPAGINA , CLIENT_ID} from '../../app.config';


@Injectable()
export class PermissaoService{
  constructor(
    private http: HttpClient,
    private router: Router,
    private login: LoginService){}


    buscarPorParametro(param: string, pagina: Number): Observable<any>{
      const headers = new HttpHeaders().set('noloader', 't');

      if (param.length > 0){
        return this.http.get<any>( `${API}/api/permissao/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {headers: headers});
      }else{
        return this.http.get<any>( `${API}/api/permissao?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {headers: headers});
      }
    }

    buscarPorId(id: number): Observable<any>{
        return this.http.get<any>( `${API}/api/permissao/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    buscarPermissoes(): Observable<any>{
        return this.http.get<any>( `${API}/api/permissao/todas/?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any>{
      return this.http.delete<any>( `${API}/api/permissao/${id}`);
    }

    salvar(permissao: Permissao): Observable<any>{
      if (permissao.Id > 0){
        return this.http.put<any>( `${API}/api/permissao/${permissao.Id}`, permissao);
      }else{
        return this.http.post<any>( `${API}/api/permissao/`, permissao);
      }

    }


  }
